export const AVATAR_SIZES = [
  "xxSmall",
  "xSmall",
  "small",
  "medium",
  "large",
  "xLarge",
] as const;

export const AVATAR_ICON_POSITIONS = ["topRight", "bottomRight"] as const;

export const AVATAR_ICON_SIZES = ["small", "medium", "large"] as const;

export const AVATAR_LARGEST_SIZE = 96;
